<div class="entity-config-detail-page container-fluid px-2 px-md-3 py-1">
  <div class="entity-config-shell d-flex flex-column gap-2 mx-auto">
    <section class="entity-config-top mb-4 rounded-4 overflow-hidden shadow-sm">
      <div class="entity-config-top-hero px-2 px-md-2 py-2">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">{{ entity_type_name }} Entity</h1>
            <p class="entity-page-subtitle text-white mb-0 subsystem-subtitle">
              Seamlessly orchestrate and scale multi-cloud automation nodes and configuration schemas.
            </p>
          </div>

          <div class="col-auto d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-light entity-action-btn btn-sm rounded-small shadow-sm fw-semibold d-inline-flex align-items-center justify-content-center px-2 py-1 border-0 text-white text-nowrap"
              @click="go_to_entity_overview"
            >
              <i class="bi bi-eye-fill me-2 text-white"></i>
              Entity Overview
            </button>
          </div>
        </div>
      </div>

      <div class="px-2 px-md-2 pb-2">
        <section class="row g-2 entity-config-top-metrics">
          <div
            v-for="metric in subsystem_metrics"
            :key="metric.label"
            class="col-12 col-sm-4 mt-2 mt-sm-0"
          >
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    {{ metric.label }}
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ metric.value }}</div>
                </div>

                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi" :class="metric.icon"></i>
                </div>
              </div>
            </article>
          </div>
        </section>
      </div>
    </section>

    <section class="entity-subsystem-tabs rounded-4 border shadow-sm p-2">
      <div class="d-flex flex-wrap gap-2">
        <button
          v-for="tab in tabs"
          :key="tab.key"
          type="button"
          class="btn btn-sm rounded-small px-3 py-2 small fw-semibold"
          :class="active_tab === tab.key ? 'btn-light text-dark-purple shadow-sm border' : 'btn-transparent text-secondary'"
          @click="active_tab = tab.key"
        >
          {{ tab.label }}
        </button>
      </div>
    </section>

    <section class="row g-3" v-if="active_tab === 'forms'">
      <div class="col-12 col-xl-8">
        <div class="entity-binding-workspace bg-white bg-opacity-75 rounded-4 border shadow p-3 h-100">
          <div class="d-flex flex-wrap align-items-start justify-content-between gap-2 mb-3">
            <div>
              <h2 class="fs-5 fw-bold mb-1">Active Form Bindings</h2>
            </div>
            <span class="entity-detail-pill entity-status-active rounded-pill fw-bold text-uppercase">{{ form_bindings.length }} Active</span>
          </div>

          <div class="entity-new-binding-card bg-white rounded-4 border p-3 mb-3 shadow">
            <div class="d-flex align-items-start gap-2 mb-3">
              <div class="entity-new-binding-icon rounded-3 d-inline-flex align-items-center justify-content-center">
                <i class="bi bi-link-45deg"></i>
              </div>
              <div>
                <div class="fw-bold small mb-1">Add New Binding</div>
                <div class="entity-panel-caption small fw-semibold">Configure automated form assignment.</div>
              </div>
            </div>
            <div class="row g-3 align-items-end">
              <div class="col-12 col-lg-8">
                <label class="form-label mb-1 fw-semibold text-uppercase entity-binding-field-label">Select Form Template</label>
                <div ref="formMultiselect" class="template-multiselect position-relative">
                  <button type="button"
                    class="form-select subsystem-select entity-binding-control rounded-small d-flex align-items-center justify-content-between gap-2"
                    :disabled="creating_binding" @click="toggle_form_dropdown">
                    <span class="text-truncate">{{ selected_forms_label }}</span>
                    <i class="bi bi-chevron-down small"></i>
                  </button>

                  <div v-if="form_dropdown_open" class="template-multiselect-menu rounded-small shadow-sm mt-1 p-2">
                    <div v-if="!bindable_forms.length" class="px-2 py-1 small text-secondary">No forms available</div>
                    <div v-else class="template-multiselect-items">
                      <label v-for="form in bindable_forms" :key="form.id"
                        class="template-multiselect-item d-flex align-items-center gap-2 px-2 py-1 rounded-small">
                        <input class="form-check-input mt-0" type="checkbox" :value="String(form.id)"
                          v-model="selected_form_ids" />
                        <span class="small text-truncate">{{ form.form_name }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-4">
                <label class="form-label mb-1 fw-semibold text-uppercase entity-binding-field-label">Priority Rank</label>
                <div class="entity-priority-control d-flex align-items-center rounded-small overflow-hidden">
                  <button type="button" class="entity-priority-step align-self-stretch border-0" @click="selected_priority = Math.max(0, Number(selected_priority || 0) - 1)">
                    <i class="bi bi-dash"></i>
                  </button>
                  <input v-model.number="selected_priority" type="number" min="0" class="form-control entity-binding-priority-input text-center border-0 fw-bold" />
                  <button type="button" class="entity-priority-step align-self-stretch border-0" @click="selected_priority = Number(selected_priority || 0) + 1">
                    <i class="bi bi-plus"></i>
                  </button>
                </div>
              </div>
              <div class="col-12">
                <div class="entity-panel-caption small fw-semibold mb-3">
                  Note: High priority forms are typically shown first during entity onboarding.
                </div>
                <div class="d-grid">
                  <button
                    type="button"
                    class="btn entity-create-binding-btn rounded-small shadow-sm px-3 py-2 fw-semibold border-0 text-white"
                    :disabled="creating_binding || !selected_form_ids.length"
                    @click="add_form_bindings"
                  >
                    <i class="bi bi-link-45deg me-2"></i>
                    {{ creating_binding ? 'Creating Binding...' : 'Create Binding(s)' }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
            <div class="fw-bold small">Current Bindings</div>
            <div class="entity-panel-caption small fw-semibold">{{ form_bindings.length }} configured</div>
          </div>

          <div class="d-flex flex-column gap-2">
            <div
              v-for="binding in form_bindings"
              :key="binding.id"
              class="entity-binding-list-card bg-white d-flex align-items-start justify-content-between gap-3 rounded-4 p-3 shadow-sm"
            >
              <div class="d-flex align-items-start gap-3 flex-grow-1">
                <div class="entity-summary-icon rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0">
                  <i class="bi bi-file-earmark-text-fill"></i>
                </div>
                <div class="flex-grow-1">
                  <div class="d-flex flex-wrap align-items-center gap-2 mb-1">
                    <div class="fw-bold small">{{ binding.form_name }}</div>
                    <span class="fw-bold small text-uppercase entity-mini-label">Priority {{ binding.priority }}</span>
                  </div>
                  <div class="small text-secondary">
                    {{ describe_binding(binding) }}
                  </div>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-link btn-sm p-0 text-danger text-decoration-none small fw-semibold"
                @click="remove_form_binding(binding)"
              >
                <i class="bi bi-trash3 me-1"></i>
                Remove
              </button>
            </div>

            <div v-if="!form_bindings.length" class="entity-activity-card rounded-4 p-3 small text-secondary bg-white">
              No form bindings yet. Add the first form above.
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-4">
        <div class="entity-overview-profile-card rounded-4 border shadow p-4 h-100 overflow-hidden">
          <h2 class="entity-overview-title fw-bold mb-3">Entity Overview</h2>
          <div class="small mb-4">
            <div class="entity-panel-caption fw-semibold">Current context for</div>
            <div class="fw-bold">{{ entity_type_name }}</div>
          </div>

          <div class="entity-overview-divider"></div>

          <div class="d-flex flex-column gap-3 my-4">
            <div class="d-flex align-items-center justify-content-between gap-2">
              <span class="small text-secondary">Active Workflows</span>
              <span class="small fw-bold">12</span>
            </div>
            <div class="d-flex align-items-center justify-content-between gap-2">
              <span class="small text-secondary">Form Sources</span>
              <span class="small fw-bold">{{ form_bindings.length }}</span>
            </div>
          </div>

          <button type="button" class="btn entity-overview-profile-btn rounded-small w-100 small fw-semibold" @click="go_to_entity_overview">
            <i class="bi bi-eye me-2"></i>
            View Full Profile
          </button>
        </div>
      </div>
    </section>

    <section class="row g-3" v-else-if="active_tab === 'workflow'">
      <div class="col-12">
        <WorkflowBinding
          :entity-type-name="entity_type_name"
          :system-name="system_name"
          :form-bindings-count="form_bindings.length"
          :workflow-bindings="workflow_bindings"
          :available-workflows="bindable_workflows"
          :selected-workflow-id="selected_workflow_id"
          :creating-workflow-binding="creating_workflow_binding"
          @update:selected-workflow-id="selected_workflow_id = $event"
          @bind-workflow="add_workflow_binding"
          @remove-workflow="remove_workflow_binding"
        />
      </div>
    </section>

    <section class="row g-3" v-else-if="active_tab === 'rules'">
      <div class="col-12 col-xl-8">
        <div class="entity-binding-workspace bg-white bg-opacity-75 rounded-4 border shadow p-3 h-100">
          <div class="d-flex flex-wrap align-items-start justify-content-between gap-2 mb-3">
            <div>
              <h2 class="fs-5 fw-bold mb-1">Active Rule Bindings</h2>
              <div class="entity-panel-caption small fw-semibold">Connect compliance rules to this entity configuration.</div>
            </div>
            <span class="entity-detail-pill entity-status-active rounded-pill fw-bold text-uppercase">{{ rule_bindings.length }} Active</span>
          </div>

          <div class="entity-new-binding-card bg-white rounded-4 border shadow p-3 mb-3">
            <div class="d-flex align-items-start gap-2 mb-3">
              <div class="entity-new-binding-icon rounded-3 d-inline-flex align-items-center justify-content-center">
                <i class="bi bi-shield-check"></i>
              </div>
              <div>
                <div class="fw-bold small mb-1">Add Rule Binding</div>
                <div class="entity-panel-caption small fw-semibold">Bind an existing compliance rule to this entity setup.</div>
              </div>
            </div>
            <div class="row g-3 align-items-end">
              <div class="col-12 col-lg-9">
                <label class="form-label mb-1 fw-semibold text-uppercase entity-binding-field-label">Select Compliance Rule</label>
                <div ref="ruleMultiselect" class="template-multiselect position-relative">
                  <button type="button"
                    class="form-select subsystem-select entity-binding-control rounded-small d-flex align-items-center justify-content-between gap-2"
                    :disabled="creating_rule_binding" @click="toggle_rule_dropdown">
                    <span class="text-truncate">{{ selected_rules_label }}</span>
                    <i class="bi bi-chevron-down small"></i>
                  </button>

                  <div v-if="rule_dropdown_open" class="template-multiselect-menu rounded-small shadow-sm mt-1 p-2">
                    <div v-if="!bindable_rules.length" class="px-2 py-1 small text-secondary">No unbound rules available</div>
                    <div v-else class="template-multiselect-items">
                      <label v-for="rule in bindable_rules" :key="rule.id"
                        class="template-multiselect-item d-flex align-items-center gap-2 px-2 py-1 rounded-small">
                        <input class="form-check-input mt-0" type="checkbox" :value="String(rule.id)"
                          v-model="selected_rule_ids" />
                        <span class="small text-truncate">{{ format_rule_option(rule) }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <button
                  type="button"
                  class="btn entity-create-binding-btn rounded-small shadow-sm px-3 py-2 fw-semibold border-0 text-white w-100"
                  :disabled="creating_rule_binding || !selected_rule_ids.length"
                  @click="add_rule_bindings"
                >
                  <i class="bi bi-link-45deg me-2"></i>
                  {{ creating_rule_binding ? 'Binding...' : 'Bind Rule(s)' }}
                </button>
              </div>
            </div>
          </div>

          <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
            <div class="fw-bold small">Current Rule Bindings</div>
            <div class="entity-panel-caption small fw-semibold">{{ rule_bindings.length }} configured</div>
          </div>

          <div class="d-flex flex-column gap-2">
            <div
              v-for="binding in rule_bindings"
              :key="binding.id"
              class="entity-binding-list-card bg-white d-flex align-items-start justify-content-between gap-3 rounded-4 p-3 shadow-sm"
            >
              <div class="d-flex align-items-start gap-3 flex-grow-1">
                <div class="entity-summary-icon rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0">
                  <i class="bi bi-shield-check"></i>
                </div>
                <div class="flex-grow-1">
                  <div class="d-flex flex-wrap align-items-center gap-2 mb-1">
                    <div class="fw-bold small">{{ binding.rule_name }}</div>
                    <span class="fw-bold small text-uppercase entity-mini-label">{{ binding.logical_operator || 'AND' }}</span>
                  </div>
                  <div class="small text-secondary">
                    {{ describe_rule_binding(binding) }}
                  </div>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-link btn-sm p-0 text-danger text-decoration-none small fw-semibold"
                @click="remove_rule_binding(binding)"
              >
                <i class="bi bi-trash3 me-1"></i>
                Remove
              </button>
            </div>

            <div v-if="!rule_bindings.length" class="entity-activity-card rounded-4 p-3 small text-secondary bg-white">
              No rule bindings yet. Add a compliance rule above.
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-4">
        <div class="entity-overview-profile-card rounded-4 border shadow p-4 h-100 overflow-hidden">
          <h2 class="entity-overview-title fw-bold mb-3">Rules Context</h2>
          <div class="small mb-4">
            <div class="entity-panel-caption fw-semibold">Current context for</div>
            <div class="fw-bold">{{ entity_type_name }}</div>
          </div>

          <div class="d-flex flex-column gap-3 my-4">
            <div class="d-flex align-items-center justify-content-between gap-2">
              <span class="small text-secondary">Available Rules</span>
              <span class="small fw-bold">{{ available_rules.length }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-between gap-2">
              <span class="small text-secondary">Bound Rules</span>
              <span class="small fw-bold">{{ rule_bindings.length }}</span>
            </div>
          </div>

          <button type="button" class="btn entity-overview-profile-btn rounded-small w-100 small fw-semibold" @click="go_to_entity_overview">
            <i class="bi bi-eye me-2"></i>
            View Entity Overview
          </button>
        </div>
      </div>
    </section>

    <section class="row g-3" v-else-if="active_tab === 'template'">
      <BindTemplates
        :entity-type-id="entity_type_id"
        :entity-type-name="entity_type_name"
        :entity-config-id="Number(entity_config?.id || 0) || null"
      />
    </section>

    <section class="row g-3" v-else-if="active_tab === 'auto_verification'">
      <BindService
        :entity-type-id="entity_type_id"
        :entity-type-name="entity_type_name"
        :entity-config-id="Number(entity_config?.id || 0) || null"
      />
    </section>

    <section class="row g-3" v-else-if="active_tab === 'manual_verification'">
      <ManualVerificationBinding
        :entity-type-id="entity_type_id"
        :entity-type-name="entity_type_name"
        :entity-config-id="Number(entity_config?.id || 0) || null"
      />
    </section>

    <section v-else-if="active_tab === 'children'">
      <BindSubEntities :entity-config-id="Number(entity_config?.id || 0) || null" />
    </section>

    <section class="row g-3" v-else-if="active_tab === 'documents'">
      <DocumentBindings
        :entity-type-id="entity_type_id"
        :entity-type-name="entity_type_name"
        :entity-config-id="Number(entity_config?.id || 0) || null"
      />
    </section>

    <section v-else class="entity-detail-panel bg-white rounded-4 border shadow-sm p-4 text-center">
      <div class="small text-secondary">This subsystem tab will be connected next.</div>
    </section>
  </div>
</div>
